import React from 'react'

const Topnav= () => {
  return (
   
        <section id="topbar" class="d-flex align-items-center">
    <div class="container d-flex justify-content-center justify-content-md-between">
      <div class="contact-info d-flex align-items-center">
        <i class="bi bi-envelope d-flex align-items-center"><a href="mailto:contact@example.com">info@roundpointtech.com</a></i>
        <i class="bi bi-phone d-flex align-items-center ms-4"><span>+1 (919) 267-9857</span></i>
      </div>
      <div class="social-links d-none d-md-flex align-items-center">
        <a href="" target="_blank" class="twitter"><i class="bi bi-twitter"></i></a>
        <a href="" target="_blank" class="facebook"><i class="bi bi-facebook"></i></a>
        <a href="" target="_blank" class="linkedin"><i class="bi bi-linkedin"></i></a>
      </div>
    </div>
  </section>

   
  )
}

export default Topnav